/**
 * Kodigilo logo — renderiza /logo.png (servido pelo Vite a partir de public/).
 *
 * - <KodigiloMark size /> — uso compacto, ex: header, ícones de navegação
 * - <KodigiloLogo height /> — uso destacado, ex: tela de login
 *
 * Os dois componentes usam o mesmo arquivo. Se você quiser variantes
 * (só símbolo vs símbolo + wordmark), trocar logo.png ou criar arquivos
 * separados em /public e ajustar os src abaixo.
 */
const SRC = '/logo.png'

export function KodigiloMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src={SRC}
      alt="Kodigilo"
      width={size}
      height={size}
      className="block shrink-0 rounded-md"
      draggable={false}
    />
  )
}

export function KodigiloLogo({ height = 28 }: { height?: number }) {
  return (
    <img
      src={SRC}
      alt="Kodigilo"
      style={{ height }}
      className="block shrink-0 rounded-md w-auto"
      draggable={false}
    />
  )
}
